import React from 'react';
export function TimelineSection() {
  return <section className="py-20 px-5 bg-cream text-center reveal pt-[40px] pb-[40px]" data-id="element-318">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-319">
        Qué pasa en los 21 días
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-320">
        Un camino concreto, día por día. No hay adivinar qué toca hoy.
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 sm:gap-0 max-w-[820px] mx-auto relative" data-id="element-321">
        {/* Connecting Line (hidden on mobile) */}
        <div className="hidden sm:block absolute top-[28px] left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-forest-light to-terracotta z-0" data-id="element-322" />

        <div className="px-3 text-center relative z-10" data-id="element-323">
          <div className="w-14 h-14 bg-forest rounded-full flex items-center justify-center mx-auto mb-4 text-cream font-playfair text-[0.75rem] font-bold leading-[1.2] text-center border-4 border-cream shadow-[0_0_0_2px_var(--forest)]" data-id="element-324">
            Días
            <br data-id="element-325" />
            1–3
          </div>
          <div className="font-playfair text-base font-bold text-text-dark mb-2" data-id="element-326">
            Base y juego
          </div>
          <p className="text-[0.78rem] text-text-mid leading-[1.5] mb-2" data-id="element-327">
            Activamos la actitud positiva hacia la lectura y trabajamos la base
            sonora con juegos.
          </p>
          <div className="text-[0.78rem] text-forest font-medium italic font-lora" data-id="element-328">
            → Tu hijo quiere jugar con los sonidos.
          </div>
        </div>

        <div className="px-3 text-center relative z-10" data-id="element-329">
          <div className="w-14 h-14 bg-forest rounded-full flex items-center justify-center mx-auto mb-4 text-cream font-playfair text-[0.75rem] font-bold leading-[1.2] text-center border-4 border-cream shadow-[0_0_0_2px_var(--forest)]" data-id="element-330">
            Días
            <br data-id="element-331" />
            4–7
          </div>
          <div className="font-playfair text-base font-bold text-text-dark mb-2" data-id="element-332">
            Sonido + letra
          </div>
          <p className="text-[0.78rem] text-text-mid leading-[1.5] mb-2" data-id="element-333">
            Unimos el sonido que ya reconoce con la letra escrita. El "click"
            más importante.
          </p>
          <div className="text-[0.78rem] text-forest font-medium italic font-lora" data-id="element-334">
            → Empieza a reconocer letras sin presión.
          </div>
        </div>

        <div className="px-3 text-center relative z-10" data-id="element-335">
          <div className="w-14 h-14 bg-forest rounded-full flex items-center justify-center mx-auto mb-4 text-cream font-playfair text-[0.75rem] font-bold leading-[1.2] text-center border-4 border-cream shadow-[0_0_0_2px_var(--forest)]" data-id="element-336">
            Días
            <br data-id="element-337" />
            8–14
          </div>
          <div className="font-playfair text-base font-bold text-text-dark mb-2" data-id="element-338">
            Sílabas y primeras palabras
          </div>
          <p className="text-[0.78rem] text-text-mid leading-[1.5] mb-2" data-id="element-339">
            Combinamos sonidos y construimos las primeras palabras reales.
          </p>
          <div className="text-[0.78rem] text-forest font-medium italic font-lora" data-id="element-340">
            → Forma sus primeras palabras con orgullo.
          </div>
        </div>

        <div className="px-3 text-center relative z-10" data-id="element-341">
          <div className="w-14 h-14 bg-terracotta rounded-full flex items-center justify-center mx-auto mb-4 text-cream font-playfair text-[0.75rem] font-bold leading-[1.2] text-center border-4 border-cream shadow-[0_0_0_2px_var(--terracotta)]" data-id="element-342">
            Días
            <br data-id="element-343" />
            15–21
          </div>
          <div className="font-playfair text-base font-bold text-text-dark mb-2" data-id="element-344">
            Lectura inicial guiada
          </div>
          <p className="text-[0.78rem] text-text-mid leading-[1.5] mb-2" data-id="element-345">
            Aplicamos todo lo aprendido en textos simples. Lectura real, sin
            frustración.
          </p>
          <div className="text-[0.78rem] text-forest font-medium italic font-lora" data-id="element-346">
            → Lee y se siente capaz.
          </div>
        </div>
      </div>
    </section>;
}